import { render, staticRenderFns } from "./ideaLine.vue?vue&type=template&id=5e422572&scoped=true"
import script from "./ideaLine.vue?vue&type=script&lang=js"
export * from "./ideaLine.vue?vue&type=script&lang=js"
import style0 from "./ideaLine.vue?vue&type=style&index=0&id=5e422572&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e422572",
  null
  
)

export default component.exports